import ReviewDetails from './ReviewDetails';

export default ReviewDetails;
